import { buildHeaders } from "../../services/api";

export async function fetchOperationsContext({ projectId, assetId, accessToken, signal }) {
  const base = process.env.REACT_APP_API_BASE?.replace(/\/$/, "");
  if (!base) throw new Error("The API address is not configured.");
  const query = assetId ? `?asset_id=${encodeURIComponent(assetId)}` : "";
  const response = await fetch(`${base}/projects/${encodeURIComponent(projectId)}/operations/context${query}`, {
    headers: await buildHeaders(accessToken), signal,
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const detail = body?.detail;
    throw new Error(typeof detail === "string" ? detail : detail?.message || `Could not load Operations (${response.status}).`);
  }
  return body;
}
